var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"embed",class:{ 'active' : _vm.active }},[_c('transition',{attrs:{"name":"fade","appear":""}},[_c('iframe',{attrs:{"src":`${_vm.src}?${_vm.hash}`}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }